<mat-accordion>
    <div class="form_sections" *ngFor="let v of quote.vehicles; let i = index">
        <mat-expansion-panel [expanded]="i == 0">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4>
                        <u>
                            <span>Horsebox {{i + 1}}</span>
                        </u>
                    </h4>
                </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="row">
                <div class="col-md-10">
                    <div class="row mb-3">
                        <div class="col-md-5 text-white"><label>Registration Number:</label></div>
                        <div class="col-md-7">
                            <input 
                                type="text" 
                                name="registration_number" 
                                [value]="v.registration_number"
                                class="form-control form-control-sm" 
                                readonly
                            >
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-5 text-white"><label>Model</label></div>
                        <div class="col-md-7">
                            <input 
                                type="text" 
                                name="model" 
                                [value]="v.model" 
                                class="form-control form-control-sm"
                                readonly
                            >
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-5 text-white"><label>Make</label></div>
                        <div class="col-md-7">
                            <input 
                                type="text" 
                                name="make" 
                                [value]="v.make" 
                                class="form-control form-control-sm"
                                readonly
                            >
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-5 text-white"><label>Year of Make</label></div>
                        <div class="col-md-7">
                            <input 
                            type="text" 
                            name="year" 
                            [value]="v.year" 
                            class="form-control form-control-sm"
                            readonly
                        >
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-md-5 text-white"><label>Gross Vehicle Weight</label></div>
                        <div class="col-md-7">
                            <input 
                                type="text" 
                                name="weight" 
                                [value]="v.weight" 
                                class="form-control form-control-sm"
                                readonly
                            >
                        </div>
                    </div>
                    <!-- <div class="row mb-3">
                        <div class="col-md-5 text-white"><label>Value</label></div>
                        <div class="col-md-7">
                            <div class="input-group">
                                <div class="input-group-prepend">
                                    <span class="input-group-text dark-green-bg text-white">&pound;</span>
                                </div>
                                <input 
                                type="text" 
                                name="value" 
                                [value]="v.value" 
                                class="form-control form-control-sm"
                                readonly
                            >
                            </div>
                        </div>
                    </div> -->

                    <div class="row mb-3">
                        <div class="col-md-5 text-white"><label>Please confirm the postcode of where the horsebox is usually kept</label></div>
                        <div class="col-md-7">
                            <div class="input-group">
                                <!-- Postcode -->
                                <input
                                    type="text"
                                    class="form-control form-control-sm"
                                    name="kept_at_postcode"
                                    [value]="v.kept_at_postcode"
                                    readonly
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </mat-expansion-panel>
    </div>
</mat-accordion>
